import React from 'react';
import { CreditCard, FileText } from 'lucide-react';

const BillingSection = () => {
  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-2xl font-bold text-foreground-primary">Billing</h1>
        <p className="text-sm text-foreground-secondary mt-1">View your invoices and billing history</p>
      </div>

      {/* Current Plan */}
      <div className="glass-frosted rounded-2xl p-6 glow-subtle">
        <h2 className="text-lg font-semibold text-foreground-primary mb-4">Current Plan</h2>
        <div className="flex items-center justify-between p-4 rounded-xl bg-subtle">
          <div className="flex items-center gap-4">
            <div className="w-10 h-10 rounded-lg flex items-center justify-center" style={{ background: 'rgba(249,115,22,0.1)' }}>
              <CreditCard size={20} style={{ color: '#F97316' }} />
            </div>
            <div>
              <p className="text-sm font-semibold text-foreground-primary">Free Plan</p>
              <p className="text-xs text-foreground-muted">Community access with basic features</p>
            </div>
          </div>
          <span className="text-[10px] px-2 py-1 rounded-full font-semibold" style={{ background: 'rgba(34,197,94,0.1)', color: '#22c55e' }}>
            Active
          </span>
        </div>
      </div>

      {/* Invoices */}
      <div className="glass-frosted rounded-2xl p-6 glow-subtle">
        <h2 className="text-lg font-semibold text-foreground-primary mb-4">Invoices</h2>
        <div className="flex flex-col items-center justify-center py-12 space-y-3">
          <FileText size={32} className="text-foreground-muted" />
          <p className="text-sm text-foreground-muted">No invoices yet</p>
          <p className="text-xs text-foreground-muted">Invoices will appear here once you make a purchase.</p>
        </div>
      </div>
    </div>
  );
};

export default BillingSection;
